import { useHistory } from 'react-router-dom';
import { authenticate, continueAsGuest, goToLogin } from 'src/model/services/profile.service';
import { ProfileState } from 'src/model/state/partials/profile.model';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { stateConnect } from 'src/hooks/state/use-app-state';
import { useShowError } from 'src/components/errors/show-errors-provider';


const AuthenticationManager = (props: ProfileState & { children: React.ReactNode }) => {
    const showError = useShowError();
    const { t } = useTranslation();
    const history = useHistory();

    useEffect(() => {
        if (!props?.loaded && !props?.error && !props?.loading) {
            authenticate();
        }
        const timer = setInterval(authenticate, 600000); // check periodically
        return () => clearInterval(timer);
    }, []);

    if (props?.needsToLogin) {
        goToLogin(window?.location?.href);
    } else if (props?.sessionExpired) {
        showError({
            error: {
                messageKey: 'SESSION_EXPIRED'
            },
            acceptButtonText: t('session_expired_button'),
            showCancel: true,
            onAcceptClick: () => goToLogin(window?.location?.href),
            onCancelClick: () => {
                continueAsGuest();
                history.push('/products');
            }
        });
    } else if (props.error) {
        showError({
            error: props?.error,
            acceptButtonText: t('common_dialog_retry'),
            onAcceptClick: authenticate,
        });
    }

    return (
        <>
            {props?.loaded && !props?.error && props?.children }
        </>
    )
}

export default stateConnect(AuthenticationManager, state => state?.profile);